document.addEventListener("DOMContentLoaded", function () {
  const typeCheckboxes = document.querySelectorAll(".brand-filters input");
  const logos = document.querySelectorAll(".brand-logo-wrap");
  const clearFiltersWrap = document.querySelector('.clear-brand-filters');
  const clearFiltersBtn = document.querySelector('.clear-brand-filters span');

  function filterLogos() {
    const selectedTypes = Array.from(typeCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.value.toLowerCase().trim());

    // ✅ Show / hide clear filters
    clearFiltersWrap.style.display = selectedTypes.length > 0 ? "block" : "none";

    logos.forEach(logo => {
      const types = (logo.dataset.type || "")
        .toLowerCase()
        .split(" ")
        .map(t => t.trim())
        .filter(Boolean);

      const typeMatch =
        selectedTypes.length === 0 ||
        selectedTypes.some(type => types.includes(type));

      logo.style.display = typeMatch ? "block" : "none";
    });
  }

  // Checkbox change
  typeCheckboxes.forEach(cb => {
    cb.addEventListener("change", filterLogos);
  });

  // ✅ ONLY click on X clears filters
  if (clearFiltersBtn) {
    clearFiltersBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      typeCheckboxes.forEach(cb => (cb.checked = false));
      filterLogos();
    });
  }

  // Initial state
  clearFiltersWrap.style.display = "none";

  // ✅ Run once on load
  filterLogos();
});